import { commonTranslations } from './common';
import { headerTranslations } from './header';
import { footerTranslations } from './footer';
import { authTranslations } from './auth';
import { landingPageTranslations } from './landing-page';
import { qrCodeTranslations } from './qr-code';
import { documentGeneratorTranslations } from './document-generator';
import { documentValidatorTranslations } from './document-validator';
import { dashboardTranslations } from './dashboard';
import { modalsTranslations } from './modals';
import { componentsTranslations } from './components';
import { pageBuilderTranslations } from './page-builder';
import { plansTranslations } from './plans';

export const translations = {
  pt: {
    common: commonTranslations.pt,
    header: headerTranslations.pt,
    footer: footerTranslations.pt,
    auth: authTranslations.pt,
    hero: landingPageTranslations.pt.hero,
    features: landingPageTranslations.pt.features,
    pricing: landingPageTranslations.pt.pricing,
    qrCode: qrCodeTranslations.pt,
    documentGenerator: documentGeneratorTranslations.pt,
    documentValidator: documentValidatorTranslations.pt,
    dashboard: dashboardTranslations.pt,
    modals: modalsTranslations.pt,
    pageCard: componentsTranslations.pt.pageCard,
    pageDetails: componentsTranslations.pt.pageDetails,
    pageBuilder: pageBuilderTranslations.pt,
    plans: plansTranslations.pt,
  },
  en: {
    common: commonTranslations.en,
    header: headerTranslations.en,
    footer: footerTranslations.en,
    auth: authTranslations.en,
    hero: landingPageTranslations.en.hero,
    features: landingPageTranslations.en.features,
    pricing: landingPageTranslations.en.pricing,
    qrCode: qrCodeTranslations.en,
    documentGenerator: documentGeneratorTranslations.en,
    documentValidator: documentValidatorTranslations.en,
    dashboard: dashboardTranslations.en,
    modals: modalsTranslations.en,
    pageCard: componentsTranslations.en.pageCard,
    pageDetails: componentsTranslations.en.pageDetails,
    pageBuilder: pageBuilderTranslations.en,
    plans: plansTranslations.en,
  },
};
